<template>
	<div style="margin-top:100px">
		<div class="J-chat-response  fixed-bottom" v-if="isvisible">
			<div class="J-chat-form" v-if="session">
				<form @submit.prevent="savecomments">
					<textarea  required class="form-control J-chat-input" v-model="comments" :placeholder="language==='English'?'Comment...':'Comente...'"></textarea>
					<button class="btn J-chat-btn" type="submit">{{language==='English'?'Send':'Enviar'}}</button>
				</form>
			</div>
			<!--div class="text-center" @click="getcomments" style="margin-top:10px;" v-if="countpage > 1">
				<v-pagination
				v-model="page"
				:length="countpage"
				:total-visible="7"
				></v-pagination>
			</div-->
		</div>
		<div class="comments-container" style="margin-top:90px;margin-bottom:200px" v-if="isvisible">
			<h1 v-if="datacomments.length>0">{{language==='English'?'Comments':'Comentarios'}}</h1>
			<label v-if="datacomments.length<=0">{{language ==='English'?'No comments':'No hay Comentarios'}}</label>
			<ul v-else id="comments-list" class="comments-list">
				<li v-for="datacomments in datacomments" :key="datacomments.length">
					<div class="comment-main-level">
						<!-- Avatar -->
						<div class="comment-avatar"><img :src="datacomments._id_user.photo[0].link" alt=""></div>
						<!-- Contenedor del Comentario -->
						<div class="comment-box">
							<div class="comment-head">
								<h6 class="comment-name by-author"><p style="background:#007bff;color:white;width:40%;text-align:center" v-if="datacomments.isowner">Autor</p><a @click="goprofileuser(datacomments._id_user.username)">{{datacomments._id_user.fullname}}</a></h6>
								<span>{{datacomments.date}}</span>
								<!--i class="fa fa-reply"></i>
								<i class="fa fa-heart"></i-->
							</div>
							<div class="comment-content">
								{{datacomments.comments}}
							</div>
							<label class="fas fa-trash-alt" style="margin-left:95%;cursor:pointer;margin-bottom:10px" v-if="datacomments.isadmin" @click="deletecomment(datacomments._id)"></label>
						</div>
					</div>
					<!-- Respuestas de los comentarios -->
					<!--ul class="comments-list reply-list">
						<li>
							<div class="comment-avatar"><img src="http://i9.photobucket.com/albums/a88/creaticode/avatar_2_zps7de12f8b.jpg" alt=""></div>
							<div class="comment-box">
								<div class="comment-head">
									<h6 class="comment-name"><a href="http://creaticode.com/blog">Lorena Rojero</a></h6>
									<span>hace 10 minutos</span>
									<i class="fa fa-reply"></i>
									<i class="fa fa-heart"></i>
								</div>
								<div class="comment-content">
									Lorem ipsum dolor sit amet, consectetur adipisicing elit. Velit omnis animi et iure laudantium vitae, praesentium optio, sapiente distinctio illo?
								</div>
							</div>
						</li>

						<li>
							<div class="comment-avatar"><img src="http://i9.photobucket.com/albums/a88/creaticode/avatar_1_zps8e1c80cd.jpg" alt=""></div>
							<div class="comment-box">
								<div class="comment-head">
									<h6 class="comment-name by-author"><a href="http://creaticode.com/blog">Agustin Ortiz</a></h6>
									<span>hace 10 minutos</span>
									<i class="fa fa-reply"></i>
									<i class="fa fa-heart"></i>
								</div>
								<div class="comment-content">
									Lorem ipsum dolor sit amet, consectetur adipisicing elit. Velit omnis animi et iure laudantium vitae, praesentium optio, sapiente distinctio illo?
								</div>
							</div>
						</li>
					</ul-->
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
const env = require('../../../../config/env.example')
const alertify  = require('alertifyjs')
import {CommentsprojectService,FileserverService} from "@/services"
import moment from 'moment'


export default {
    data(){
        return{
        	language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : '',
			page: 1,
			countpage: 0,
			comments: '',
			isowner: false,
			datacomments:[],
			isvisible:false,
			session : JSON.parse(localStorage.getItem('user'))
        }
	},
	sockets:{
        'new_comments'(){
            this.getcomments()
		},
		'getdatadeletecomment'(data){
			if(data){
				let isequalidproject = data.idproject === this.$route.params.idproject
				if(isequalidproject){
					this.getcomments()
				}
			}
		}
	},
	
	created(){
		this.projectexist()
		this.getcomments()
	},
	mounted(){
		if(this.language === 'English'){
            moment.locale('us')
        }else{
            moment.locale('es')
        }
		EventBus.$on('changelanguage',()=>{
            let choosedlanguage = JSON.parse(localStorage.getItem('language'))
            this.language = choosedlanguage.language
            //console.log(this.language)
            //console.log(choosedlanguage)
        })
        let choosedlanguage = JSON.parse(localStorage.getItem('language'))
        if(choosedlanguage){
            this.language = choosedlanguage.language
        }
	},
    methods:{
		deletecomment(idcomment){
			let query = {
				idcomment : idcomment,
				idproject:this.$route.params.idproject
			}
			this.$socket.emit('deletecomment',query)
		},
		goprofileuser(username){
            window.location = `${env.default.host}${username}`
        },
		projectexist(){
			let idproject = this.$route.params.idproject
			let userloged = JSON.parse(localStorage.getItem('user'))
			//console.log(userloged)
			if(userloged){
				let query = {
					idproject : idproject
				}
				FileserverService.showprojectasadmin(query).then(res=>{
					this.isowner = true
				})
				.catch((err)=>{
					this.isowner = false
				})
			}
		},
		getcountcomments(){
			let idproject = this.$route.params.idproject
			let query = {
				idproject:idproject
			}
				FileserverService.projectexist(query).then(res=>{
					document.getElementsByTagName('title')[0].innerHTML = this.language==='English'?`Comments - ${res.data.name}`: `Comentarios - ${res.data.name}`
					axios.get(`comments/getcountcomments/${idproject}`)
					.then((res)=>{
						this.countpage = res.data.countcomments
					})
				})
				.catch((err)=>{
					this.isvisible = false
				})
		},
        getcomments(){
			this.getcountcomments()
			let idproject = this.$route.params.idproject
			let query = {
				idproject:idproject
			}
				FileserverService.projectexist(query).then(res=>{
					this.isvisible = true
					//console.log(this.page)
					let query = {
						idproject:idproject,
						page:this.page
					}
					CommentsprojectService.list(query).then(res=>{
						if(res.data.results.length>0){
							this.datacomments = []
							res.data.results.forEach(element=>{
								let datenew = moment(element.date).fromNow()
								element.date = datenew
							})
							this.datacomments = res.data.results
							let session = JSON.parse(localStorage.getItem('user'))
							let iduser = JSON.parse(localStorage.getItem('iden'))
							if(session){
								this.datacomments.forEach(element => {
									if(this.isowner){
										element.isadmin = true
									}else{
										if(iduser){
											if(String(element._id_user._id) === String(iduser._id)){
												element.isadmin=true
											}else{
												element.isadmin=false
											}
										}else{
											element.isadmin = false
										}
									}
								})
							}
						}
					})
					
				})
				.catch((err)=>{
					this.isvisible = false
				})
		},
		savecomments(){
			this.projectexist()
			this.getcountcomments()
			let idproject = this.$route.params.idproject
			if(this.countpage>500){
				alertify.error(this.language === 'English'?'You can only write less than 500 comments':'Solo se puede escribir menos de 500 comentarios')
			}else{
				let query = {
					idproject:idproject
				}
				FileserverService.projectexist(query).then(res=>{
						let id = JSON.parse(localStorage.getItem('iden'))._id
						let data = {
								comments: this.comments,
								_id_project: idproject,
								_id_user:id,
								isowner:this.isowner
							}
						this.$socket.emit('comments',data)
						this.comments = ""
						if(!this.isowner){
							let datanotifications = {
								path: 'Comments',
								_id_proyect: idproject,
								_id_user_sender:id,
								photo: JSON.parse(localStorage.getItem('user')).photo,
								description: JSON.parse(localStorage.getItem('user')).username
							}
							this.$socket.emit('notificationscomment',datanotifications)
						}
					})
					.catch((err)=>{
						alertify.error(this.language?'Error in save your comment':'Error en guardar su comentario')
					})
			}
			
			
		}
	}
	
}

</script>
<style lang="scss" scoped>
/**
 * Oscuro: #283035
 * Azul: #03658c
 * Detalle: #c7cacb
 * Fondo: #dee1e3
 ----------------------------------*/
 * {
 	margin: 0;
 	padding: 0;
 	-webkit-box-sizing: border-box;
 	-moz-box-sizing: border-box;
 	box-sizing: border-box;
 }

 a {
 	color: #03658c;
 	text-decoration: none;
 }

ul {
	list-style-type: none;
}

body {
	font-family: 'Roboto', Arial, Helvetica, Sans-serif, Verdana;
	background: #dee1e3;
}
.J-chat-response{
	margin-left:5%;
	margin-bottom: 10px;
	width:90%;
	.J-chat-form{
		position: relative;
		.J-chat-input{
			height: 40px;
			padding: 10px;
		}
		.J-chat-btn{
			position:  absolute;
			top: 0;
			right: 0;
			width:45px;
			outline: none;
			height: 40px;
			background-color: #007bff;
			color: #fff;
			&:focus{
				box-shadow: none;
			}
		}
	}
}

/** ====================
 * Lista de Comentarios
 =======================*/
.comments-container {
	margin: 60px auto 15px;
	width: 768px;
}

.comments-container h1 {
	font-size: 36px;
	color: #283035;
	font-weight: 400;
}

.comments-container h1 a {
	font-size: 18px;
	font-weight: 700;
}

.comments-list {
	margin-top: 30px;
	position: relative;
}

/**
 * Lineas / Detalles
 -----------------------*/
.comments-list:before {
	content: '';
	width: 2px;
	height: 100%;
	background: #c7cacb;
	position: absolute;
	left: 32px;
	top: 0;
}

.comments-list:after {
	content: '';
	position: absolute;
	background: #c7cacb;
	bottom: 0;
	left: 27px;
	width: 7px;
	height: 7px;
	border: 3px solid #dee1e3;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
}

.reply-list:before, .reply-list:after {display: none;}
.reply-list li:before {
	content: '';
	width: 60px;
	height: 2px;
	background: #c7cacb;
	position: absolute;
	top: 25px;
	left: -55px;
}


.comments-list li {
	margin-bottom: 15px;
	display: block;
	position: relative;
}

.comments-list li:after {
	content: '';
	display: block;
	clear: both;
	height: 0;
	width: 0;
}

.reply-list {
	padding-left: 88px;
	clear: both;
	margin-top: 15px;
}
/**
 * Avatar
 ---------------------------*/
.comments-list .comment-avatar {
	width: 65px;
	height: 65px;
	position: relative;
	float: left;
	border: 3px solid #FFF;
	-webkit-border-radius: 4px;
	-moz-border-radius: 4px;
	border-radius: 4px;
	-webkit-box-shadow: 0 1px 2px rgba(0,0,0,0.2);
	-moz-box-shadow: 0 1px 2px rgba(0,0,0,0.2);
	box-shadow: 0 1px 2px rgba(0,0,0,0.2);
	overflow: hidden;
}

.comments-list .comment-avatar img {
	width: 100%;
	height: 100%;
}

.reply-list .comment-avatar {
	width: 50px;
	height: 50px;
}

.comment-main-level:after {
	content: '';
	width: 0;
	height: 0;
	display: block;
	clear: both;
}
/**
 * Caja del Comentario
 ---------------------------*/
.comments-list .comment-box {
	width: 680px;
	float: right;
	position: relative;
	-webkit-box-shadow: 0 1px 1px rgba(0,0,0,0.15);
	-moz-box-shadow: 0 1px 1px rgba(0,0,0,0.15);
	box-shadow: 0 1px 1px rgba(0,0,0,0.15);
}

.comments-list .comment-box:before, .comments-list .comment-box:after {
	content: '';
	height: 0;
	width: 0;
	position: absolute;
	display: block;
	border-width: 10px 12px 10px 0;
	border-style: solid;
	border-color: transparent #FCFCFC;
	top: 8px;
	left: -11px;
}

.comments-list .comment-box:before {
	border-width: 11px 13px 11px 0;
	border-color: transparent rgba(0,0,0,0.05);
	left: -12px;
}

.reply-list .comment-box {
	width: 610px;
}
.comment-box .comment-head {
	background: #FCFCFC;
	padding: 10px 12px;
	border-bottom: 1px solid #E5E5E5;
	overflow: hidden;
	-webkit-border-radius: 4px 4px 0 0;
	-moz-border-radius: 4px 4px 0 0;
	border-radius: 4px 4px 0 0;
}

.comment-box .comment-head i {
	float: right;
	margin-left: 14px;
	position: relative;
	top: 2px;
	color: #A6A6A6;
	cursor: pointer;
	-webkit-transition: color 0.3s ease;
	-o-transition: color 0.3s ease;
	transition: color 0.3s ease;
}

.comment-box .comment-head i:hover {
	color: #03658c;
}

.comment-box .comment-name {
	color: #283035;
	font-size: 14px;
	font-weight: 700;
	float: left;
	margin-right: 10px;
}

.comment-box .comment-name a {
	color: #283035;
}

.comment-box .comment-head span {
	float: left;
	color: #999;
	font-size: 13px;
	position: relative;
	top: 1px;
}

.comment-box .comment-content {
	background: #FFF;
	padding: 12px;
	font-size: 15px;
	color: #595959;
	-webkit-border-radius: 0 0 4px 4px;
	-moz-border-radius: 0 0 4px 4px;
	border-radius: 0 0 4px 4px;
}

.comment-box .comment-name.by-author, .comment-box .comment-name.by-author a {color: #03658c;}
.comment-box .comment-name.by-author:after {
	background: #03658c;
	color: #FFF;
	font-size: 12px;
	padding: 3px 5px;
	font-weight: 700;
	margin-left: 10px;
	-webkit-border-radius: 3px;
	-moz-border-radius: 3px;
	border-radius: 3px;
}

/** =====================
 * Responsive
 ========================*/
@media only screen and (max-width: 766px) {
	.comments-container {
		width: 480px;
	}

	.comments-list .comment-box {
		width: 390px;
	}

	.reply-list .comment-box {
		width: 320px;
	}
}
@media only screen and (max-width: 500px) {
	.comments-container {
		width: 300px;
	}

	.comments-list .comment-box {
		width: 300px;
	}

	.reply-list .comment-box {
		width: 300px;
	}
}
@media only screen and (max-width: 500px) {
	.J-chat-response{
		width: 90%;
	}
}

</style>
